<template>
    <div class="page__container">
        <router-view/>
    </div>
</template>


<script>
    import i18n from './lang/lang'
    import conf from '../public/site_config.json'
    import router from './router'
    
    export default {
        name: 'app',
        data: function () {
            return {
                
            }
        },
        methods: {
            
        },
        mounted() {
            this.updateMixins()
        }
    }
</script>




<style src="./assets/fonts/fonts.css"></style>
<style lang="stylus">
    html
        min-width 320px
        height 100%

    body
        margin 0
        padding 0
        font-family Gilroy, Arial, sans-serif
        -webkit-font-smoothing antialiased
        -moz-osx-font-smoothing grayscale
        display flex
        height 100%
        line-height 1.7
        font-size 14px
        background #222
        
        @media (min-width 1600px)
            font-size 16px

    body.aboutPage, body.contactPage
        background #fff

    .outer_pages
        display: none
            
    body:not(.homePage) .outer_pages
        display block
        
    body:not(.homePage) .homePage_logo
        display none
            
    h1, h2
        font-weight normal
        margin 0
        padding 0

    ul
        padding 0
        margin 0
        list-style none

    a
        color inherit
        text-decoration none

    .vidget_wrap
        @media (min-width 1024px)
            min-height 100vh !important
            padding-top 0 !important
            padding-bottom 0 !important

    .page__container
        width 100%
        /*min-height 100%*/
        overflow hidden
    
    body.fp-responsive .page__container
        overflow auto

    body.scrolledPage 
        display block

    .page__wrapper
        margin 0 auto
        padding 32px 20px 0
        box-sizing border-box
        min-height 100%

        @media (min-width 700px)
            padding 40px 35px 0
        
        @media (min-width 1024px)
            padding 40px 80px 0
            
        @media (min-width 1600px)
            padding 40px 100px 0

    .page__section
        padding 25px 20px

        @media (min-width 700px)
            padding 35px
        
        @media (min-width 1024px)
            padding 80px 80px 80px 250px
            
        @media (min-width 1600px)
            padding 80px 100px 80px 250px

    .page__h1, h1
        font-size 36px
        font-weight bold
        line-height 1.2

        @media (min-width 1024px)
            font-size 48px
            
        @media (min-width 1600px)
            font-size 64px

    .page__h2, h2
        font-size 24px
        line-height 1.5
        
        @media (min-width 1600px)
            font-size 36px
            line-height 120%

    .page__process
        height 100%

    .automation__link
        display none
        margin-top 16px
        color #999
        -webkit-transition .3s cubic-bezier(.25,.01,.25,1)
        -moz-transition .3s cubic-bezier(.25,.01,.25,1)
        transition .3s cubic-bezier(.25,.01,.25,1)

        &:hover
            color #000

        @media (min-width 1024px)
            display inline-block

    .automation__link 
        span
            font-size 14px
            position relative
            display inline-block
            padding-left 5px
            top 2px
            -webkit-transform rotate(-45deg)
            -moz-transform rotate(-45deg)
            transform rotate(-45deg)

    .button
        color #fff
        position relative
        padding-right 24px
        transition .2s linear
        line-height 50px
        font-weight 600
        display inline-block
        -webkit-transition .3s cubic-bezier(.25,.01,.25,1)
        -moz-transition .3s cubic-bezier(.25,.01,.25,1)
        transition .3s cubic-bezier(.25,.01,.25,1)

        &:before
            content ''
            width 76px
            height 50px
            background #2858A2
            border-radius 25px
            position absolute
            top 50%
            right 0
            transform translateY(-50%)
            transition .2s linear

        &:hover
            transform translateX(24px)
            &:before
                width 100%
                padding-left 24px
            

    .button_white
        color #000

        &:hover
            color #fff

    .button_gray
        &:before
            background #7A7D80

    .button__text
        position relative

    .hiddenBack
        display none !important

    .home_screen, .marketing_screen, .service_screen
        min-height 100%

    .content_wrapper 
        position absolute
        top 0
        left 0
        width 100%
        height 100%
        background #222
        -webkit-transition all .5s cubic-bezier(.25,.01,.25,1)
        -moz-transition all .5s cubic-bezier(.25,.01,.25,1)
        transition all .5s cubic-bezier(.25,.01,.25,1)

    .fader
        width 0
        height 100%
        position fixed
        top 0
        right 0
        z-index 500
        overflow hidden
        background #141414
        -webkit-transition .4s linear
        -moz-transition .4s linear
        transition .4s linear
        
        @media (max-width 1023px)
            -webkit-transition .2s linear
            -moz-transition .2s linear
            transition .2s linear
        
        &:after
            width 26px
            height 26px
            font-size 26px
            color #fff
            position fixed
            top calc(50% - 13px)
            left calc(50% - 13px)
            display none
            content '\0070'
            font-family 'smart_icons'
            font-style normal
            font-weight normal
            line-height 1
            -webkit-font-smoothing antialiased
            -moz-osx-font-smoothing grayscale

    body.faderIn
        .fader
            width 100%
            left auto
            right 0
            
            &:after
                display block
                -webkit-transition-delay .2s
                -moz-transition-delay .2s
                transition-delay .2s
            
    body.faderOut
        .fader
            width 0%
            left 0
            right auto
            
            &:after
                display none
                -webkit-transition-delay .2s
                -moz-transition-delay .2s
                transition-delay .2s

    body.menuOpen .content_wrapper
        top 280px
    
    .mobile_brands_list
        opacity 0
        width 100vw
        height 100vh
        position fixed
        top 0
        left 0
        z-index -1
        overflow hidden
        -webkit-transition .3s ease
        -moz-transition .3s ease
        transition .3s ease
        
        .brands_screen_vidget
            left 100vw
            -webkit-transition .3s ease
            -moz-transition .3s ease
            transition .3s ease
            
            .br_list_title
                padding-top 20px
            
            .br_list_wrp
                overflow-y scroll
                height calc(100vh - 60px)
    
    body.brandsListOpen
        overflow hidden !important
        height 100vh !important
        
        .mobile_brands_list
            z-index 1000
            opacity 1
            
        &.brandsIn
            .mobile_brands_list
                .brands_screen_vidget
                    left 0
                    -webkit-transition-delay .2s
                    -moz-transition-delay .2s
                    transition-delay .2s
                    
                    &:before
                        left 0
                        -webkit-transition-delay .4s
                        -moz-transition-delay .4s
                        transition-delay .4s
                        
                    .textHide
                        span
                            top 0
                            -webkit-transition-delay .8s
                            -moz-transition-delay .8s
                            transition-delay .8s
                            
                    .textFade
                        top 0
                        opacity 1
                        -webkit-transition-delay 1s
                        -moz-transition-delay 1s
                        transition-delay 1s
        
        [data-anchor="brands"]
            .fp-slidesContainer
                -webkit-transform translate3d(0px, 0px, 0px) !important
                -moz-transform translate3d(0px, 0px, 0px) !important
                transform translate3d(0px, 0px, 0px) !important
    
    .br_list_wrap
        width 100%
        height auto
        margin 0
        overflow hidden
        overflow-y auto
        
        @media (min-width 1024px)
            width calc(100% - 240px)
            max-width 700px
            height calc(100% - 200px)
            margin 0 0 0 120px
        
    .br_list_title
        display block
        font-size 24px
        color #000
        margin 120px 0 0 120px
        
    .br_list_container
        width 100%
       
    .br_lisr_cont_wrap
        padding 30px 0 0
        
    .brnd_item
        width calc(50% - 16px)
        height 80px
        margin 8px
        display inline-block
        text-align center
        line-height 80px
        color #D5D7DB
        font-size 80px
        overflow hidden
        
        @media (max-width 1023px)
            line-height 80px
            font-size 80px
            
            .icon-b_apple
                font-size 55px
                
            .icon-b_amaz
                font-size 130px
                
                &:before
                    position relative
                    top -20px
                
            .icon-b_harman
                font-size 140px
                
                &:before
                    position relative
                    top -30px
                    
            .icon-b_jbl, .icon-b_mi
                font-size 60px
                
            .icon-b_ravpower
                font-size 120px
                
                &:before
                    position relative
                    top -15px
                    
            .icon-b_yunmai
                font-size 110px
                
                &:before
                    position relative
                    top -10px
                    
            .icon-b_ecovacs
                font-size 100px
                
                &:before
                    position relative
                    top -15px
        
        @media (min-width 1024px)
            width calc(33.3% - 16px)
            height 100px
            line-height 90px
            margin 8px 16px 8px 0
            font-size 90px
            
            .icon-b_apple
                font-size 55px
                
            .icon-b_amaz
                font-size 130px
                
                &:before
                    position relative
                    top -20px
                
            .icon-b_harman
                font-size 140px
                
                &:before
                    position relative
                    top -30px
                    
            .icon-b_jbl, .icon-b_mi
                font-size 70px
                
            .icon-b_ravpower
                font-size 120px
                
                &:before
                    position relative
                    top -15px
                    
            .icon-b_yunmai
                font-size 130px
                
                &:before
                    position relative
                    top -20px
    
    
    
    
        
    body.menuOpen .main_logo
        color #000
        
        &:hover
            color #000
            opacity .8
    
    body.menuOpen .auth_link
        &:hover
            color #000

    body.menuOpen .languages__item
        &:hover
            color #000
            
    body.menuOpen .languages__item_active
        color #000
        
        &:before
            background #000
        
    .for_mob
        display block
        
        @media (min-width 1024px)
            display none

            
    body:not(.fp-responsive) {
        .fullpage-wrapper {
            width: 100% !important;
            transform: none !important;

            .fp-section {
                width: 100% !important;
                position: absolute;
                left: 0;
                top: 100vh;
                z-index: 1;
                -webkit-transition top .6s ease
                -moz-transition top .6s ease
                transition top .6s ease
                -webkit-transition-delay .5s
                -moz-transition-delay .5s
                transition-delay .5s
                
                &.active {
                    top: 0;
                }

                &.active + .fp-section {
                    top: 100vh;
                }
            }
            
            .fp-section:not(.startAnim) * {
                -webkit-transition-delay: 0s !important;
                -moz-transition-delay: 0s !important;
                transition-delay: 0s !important;
            }

            .fp-controlArrow {
                display: none;
            }
            
            .fp-slidesContainer {
                width: 100% !important;
                transform: none !important;
                
                .fp-slide {
                    width: 100% !important;
                    position: absolute;
                    left: 0;
                    top: 0;
                    z-index: 1;
                    -webkit-transition left .6s ease
                    -moz-transition left .6s ease
                    transition left .6s ease
                    
                    &.active {
                        left: 0;
                    }

                    &.brList.active {
                        @media (min-width 1260px) {
                            width: calc(100% - 325px) !important
                            left: 325px;
                        }
                        
                        @media (max-width 1259px) {
                            width 100% !important
                            left 0
                        }
                    }

                    &.active + .fp-slide {
                        left: 100vw;
                    }
                }
            }
        }
        
        &.fp-viewing-approach {
            .fullpage-wrapper {
                .fp-section[data-anchor="home"] {
                    top: 0;
                }
            }
        }
        &.fp-viewing-scale {
            .fullpage-wrapper {
                .fp-section[data-anchor="home"], .fp-section[data-anchor="approach"] {
                    top: 0;
                }
            }
        }
        &.fp-viewing-brands-0, &.fp-viewing-brands-1 {
            .fullpage-wrapper {
                .fp-section[data-anchor="home"], .fp-section[data-anchor="approach"], .fp-section[data-anchor="scale"] {
                    top: 0;
                }
            }
        }
        &.fp-viewing-marketing_support {
            .fullpage-wrapper {
                .fp-section[data-anchor="home"], .fp-section[data-anchor="approach"], .fp-section[data-anchor="scale"], .fp-section[data-anchor="brands"] {
                    top: 0;
                }
            }
        }
        &.fp-viewing-customer_service {
            .fullpage-wrapper {
                .fp-section[data-anchor="home"], .fp-section[data-anchor="approach"], .fp-section[data-anchor="scale"], .fp-section[data-anchor="brands"], .fp-section[data-anchor="marketing_support"] {
                    top: 0;
                }
            }
        }
        &.fp-viewing-software_integration {
            .fullpage-wrapper {
                .fp-section[data-anchor="home"], .fp-section[data-anchor="approach"], .fp-section[data-anchor="scale"], .fp-section[data-anchor="brands"], .fp-section[data-anchor="marketing_support"], .fp-section[data-anchor="customer_service"] {
                    top: 0;
                }
            }
        }
    }

    @media (max-width 1259px)
        .numbers_wraps
            width 100%
          
    
    
    /* animations */
    @media (min-width 1260px)
        .button
            top 10px
            opacity 0
            
            &:before
                width 100%
        
        .textHide
            display block
            overflow hidden
            -webkit-transition-delay .2s
            -moz-transition-delay .2s
            transition-delay .2s

            span
                position relative
                top 85px
                -webkit-transition .3s cubic-bezier(.25,.01,.25,1)
                -moz-transition .3s cubic-bezier(.25,.01,.25,1)
                transition .3s cubic-bezier(.25,.01,.25,1)
                
        .textFade, .textFade_delay
            opacity 0
            position relative
            top 20px
            -webkit-transition .3s cubic-bezier(.25,.01,.25,1)
            -moz-transition .3s cubic-bezier(.25,.01,.25,1)
            transition .3s cubic-bezier(.25,.01,.25,1)
            
        .textFade_delay
            -webkit-transition-delay .8s
            -moz-transition-delay .8s
            transition-delay .8s
        
        .fadeTop
            opacity 0
            position relative
            top 40px
            -webkit-transition .5s cubic-bezier(.25,.01,.25,1)
            -moz-transition .5s cubic-bezier(.25,.01,.25,1)
            transition .5s cubic-bezier(.25,.01,.25,1)
            
        .process__circle
            opacity 0
            
            &:after
                -webkit-transform rotate(-20deg)
                -moz-transform rotate(-20deg)
                transform rotate(-20deg)
               
        .process__item
            opacity 0

        .process__item_first
            margin-right 10px
            
        .process__item_second
            margin -10px 8px 0 0
            
        .process__item_third
            margin -10px -6px 0 0
            
        .process__item_fourth
            margin-right -10px
            
        .process__item_fifth
            margin 10px -8px 0 0
            
        .process__item_sixth
            margin 8px 6px 0 0
            
        .channel__wrapper
            overflow hidden
            
            .channel__map
                &:before
                    opacity 0
                    margin 0 0 0 40px
                    
            #map
                -webkit-transition .3s cubic-bezier(.25,.01,.25,1)
                -moz-transition .3s cubic-bezier(.25,.01,.25,1)
                transition .3s cubic-bezier(.25,.01,.25,1)
                -webkit-transform scale(1.1)
                -moz-transform scale(1.1)
                transform scale(1.1)
                opacity 0
            
        .numbers_wraps
            width 0
            -webkit-transition .2s linear
            -moz-transition .2s linear
            transition .2s linear
            
            &:after
                width 100%
                height 100%
                position absolute
                top 0
                left 0
                content ''
                background #DFDFDF
                -webkit-transition .2s linear
                -moz-transition .2s linear
                transition .2s linear
                
        .categories__item
            -webkit-transition .3s cubic-bezier(.25,.01,.25,1)
            -moz-transition .3s cubic-bezier(.25,.01,.25,1)
            transition .3s cubic-bezier(.25,.01,.25,1)
            position relative
            left 25px
            opacity 0

        .animSection
            position relative
            
            &:before
                top 100vh
                -webkit-transition .5s cubic-bezier(.25,.01,.25,1)
                -moz-transition .5s cubic-bezier(.25,.01,.25,1)
                transition .5s cubic-bezier(.25,.01,.25,1)
                -webkit-transition-delay .2s
                -moz-transition-delay .2s
                transition-delay .2s
            
            .textHide
                span
                    -webkit-transition-delay .8s
                    -moz-transition-delay .8s
                    transition-delay .8s
                
        .backMapWrap
            -webkit-transform scale(1.1)
            -moz-transform scale(1.1)
            transform scale(1.1)
            -webkit-transition .3s cubic-bezier(.25,.01,.25,1)
            -moz-transition .3s cubic-bezier(.25,.01,.25,1)
            transition .3s cubic-bezier(.25,.01,.25,1)

        
            

            
            
            

        /* animation start
        ---------------------------------------------------------------------- */
        body:not(.fp-responsive)
            .fp-section.startAnimBtns, .visibleSlide
                .button
                    opacity 1
                    top 0

                    &:before
                        width 76px

                    &:hover
                        transform translateX(24px)

                        &:before
                            width 100%
                            padding-left 24px

            .fp-section.startAnim
                .textHide
                    span
                        top 0

                .textFade
                    opacity 1
                    top 0
                    -webkit-transition-delay .4s
                    -moz-transition-delay .4s
                    transition-delay .4s

                .textFade[data-chain="1"]
                    -webkit-transition-delay .5s
                    -moz-transition-delay .5s
                    transition-delay .5s

                .textFade[data-chain="2"]
                    -webkit-transition-delay .8s
                    -moz-transition-delay .8s
                    transition-delay .8s

                .textFade[data-chain="3"]
                    -webkit-transition-delay 1.2s
                    -moz-transition-delay 1.2s
                    transition-delay 1.2s

                .textFade_delay
                    opacity 1
                    top 0

                .process__circle
                    opacity 1
                    -webkit-transition-delay .7s
                    -moz-transition-delay .7s
                    transition-delay .7s

                    &:after
                        -webkit-transform rotate(0deg)
                        -moz-transform rotate(0deg)
                        transform rotate(0deg)
                        -webkit-transition-delay .8s
                        -moz-transition-delay .8s
                        transition-delay .8s

                .process__item
                    margin 0
                    opacity 1

                .channel__wrapper
                    .channel__map
                        &:before
                            margin 0
                            opacity 1
                            -webkit-animation: bounceInDown .4s 1;
                            -moz-animation: bounceInDown .4s 1;
                            animation: bounceInDown .4s 1;
                            -webkit-animation-fill-mode: forwards;
                            -moz-animation-fill-mode: forwards;
                            animation-fill-mode: forwards;

                    #map
                        -webkit-transform scale(1)
                        -moz-transform scale(1)
                        transform scale(1)
                        opacity 1

                    .textHide
                        span
                            -webkit-transition-delay .3s
                            -moz-transition-delay .3s
                            transition-delay .3s

                .numbers_wraps
                    width 100%
                    -webkit-transition-delay .5s
                    -moz-transition-delay .5s
                    transition-delay .5s

                    &:after
                        width 0
                        -webkit-transition-delay .7s
                        -moz-transition-delay .7s
                        transition-delay .7s

                .categories__item
                    left 0
                    opacity 1

                .categories__item[data-category="1"]
                    -webkit-transition-delay .3s
                    -moz-transition-delay .3s
                    transition-delay .3s

                .categories__item[data-category="2"]
                    -webkit-transition-delay .5s
                    -moz-transition-delay .5s
                    transition-delay .5s

                .categories__item[data-category="3"]
                    -webkit-transition-delay .7s
                    -moz-transition-delay .7s
                    transition-delay .7s

                .categories__item[data-category="4"]
                    -webkit-transition-delay .9s
                    -moz-transition-delay .9s
                    transition-delay .9s

                .categories__item[data-category="5"]
                    -webkit-transition-delay 1.1s
                    -moz-transition-delay 1.1s
                    transition-delay 1.1s

                .categories__item[data-category="6"]
                    -webkit-transition-delay 1.3s
                    -moz-transition-delay 1.3s
                    transition-delay 1.3s

                .animSection
                    &:before
                        top 0

                .fadeTop[data-discovery="1"]
                    top 0
                    opacity 1
                    -webkit-transition-delay 1s
                    -moz-transition-delay 1s
                    transition-delay 1s

                .fadeTop[data-discovery="2"]
                    top 0
                    opacity 1
                    -webkit-transition-delay 1.4s
                    -moz-transition-delay 1.4s
                    transition-delay 1.4s

                .fadeTop[data-discovery="3"]
                    top 0
                    opacity 1
                    -webkit-transition-delay 1.8s
                    -moz-transition-delay 1.8s
                    transition-delay 1.8s

                .backMapWrap
                    -webkit-transform scale(1)
                    -moz-transform scale(1)
                    transform scale(1)

        
            .fp-section.startAnim
                .brList
                    .textHide
                        span
                            top 70px
                            -webkit-transition-delay .7s
                            -moz-transition-delay .7s
                            transition-delay .7s

                    .textFade
                        top 50px
                        opacity 0
                        -webkit-transition-delay .9s
                        -moz-transition-delay .9s
                        transition-delay .9s

                .brList.active
                    .textHide
                        span
                            top 0

                    .textFade
                        top 0
                        opacity 1
        
                
        body.fp-responsive
            .animSection
                &:before
                    top 0
            
            .detectMobVisibility.thisVisible
                &.textHide, .textHide
                    span
                        top 0

                &.textFade, .textFade
                    opacity 1
                    top 0
                    
                &.textFade_delay, .textFade_delay
                    opacity 1
                    top 0
                    
                .button
                    opacity 1
                    top 0

                    &:before
                        width 76px

                    &:hover
                        transform translateX(24px)

                        &:before
                            width 100%
                            padding-left 24px

                .process__circle
                    opacity 1

                    &:after
                        -webkit-transform rotate(70deg)
                        -moz-transform rotate(70deg)
                        transform rotate(70deg)

                .process__item
                    margin 0
                    opacity 1

                .categories__item
                    left 0
                    opacity 1

                .categories__item[data-category="1"]
                    -webkit-transition-delay .1s
                    -moz-transition-delay .1s
                    transition-delay .1s

                .categories__item[data-category="2"]
                    -webkit-transition-delay .3s
                    -moz-transition-delay .3s
                    transition-delay .3s

                .categories__item[data-category="3"]
                    -webkit-transition-delay .5s
                    -moz-transition-delay .5s
                    transition-delay .5s

                .categories__item[data-category="4"]
                    -webkit-transition-delay .7s
                    -moz-transition-delay .7s
                    transition-delay .7s

                .categories__item[data-category="5"]
                    -webkit-transition-delay .9s
                    -moz-transition-delay .9s
                    transition-delay .9s

                .categories__item[data-category="6"]
                    -webkit-transition-delay 1.1s
                    -moz-transition-delay 1.1s
                    transition-delay 1.1s

                .fadeTop[data-discovery="1"]
                    top 0
                    opacity 1

                .fadeTop[data-discovery="2"]
                    top 0
                    opacity 1

                .fadeTop[data-discovery="3"]
                    top 0
                    opacity 1

                .backMapWrap
                    -webkit-transform scale(1)
                    -moz-transform scale(1)
                    transform scale(1)
                    
            .fp-section.startAnim
                .channel__wrapper
                    #map
                        -webkit-transform scale(1)
                        -moz-transform scale(1)
                        transform scale(1)
                        opacity 1
                
                .brList
                    position fixed
                    top 0
                    left 100vw
                    z-index 10000
                    display block
                    
                    .textHide
                        span
                            top 70px
                            -webkit-transition-delay .7s
                            -moz-transition-delay .7s
                            transition-delay .7s

                    .textFade
                        top 50px
                        opacity 0
                        -webkit-transition-delay .9s
                        -moz-transition-delay .9s
                        transition-delay .9s

                .brList.active
                    left 0
                    
                    .textHide
                        span
                            top 0

                    .textFade
                        top 0
                        opacity 1
            
            [data-chain]
                -webkit-transition-delay 0s !important
                -moz-transition-delay 0s !important
                transition-delay 0s !important
                
                
        @media (max-width 760px)
            .textHide
                span
                    top 95px
                    
                    
            .fp-section.startAnim
                .process__circle
                    &:after
                        -webkit-transform rotate(70deg)
                        -moz-transform rotate(70deg)
                        transform rotate(70deg)
                        
                        
                        
        @media (max-width 1024px)
            .detectMobVisibility.thisVisible
                &.textHide, .textHide
                    span
                        top 0

                &.textFade, .textFade
                    opacity 1
                    top 0
                    -webkit-transition-delay .4s
                    -moz-transition-delay .4s
                    transition-delay .4s
                    
                .button
                    opacity 1
                    top 0

                    &:before
                        width 76px

                    &:hover
                        transform translateX(24px)

                        &:before
                            width 100%
                            padding-left 24px
                        
                        
                        
                        
                        
                        
                        
                
        /* end animations
        --------------------------------------------------------------- */
        
    body.fp-responsive
        .fullpage-wrapper, .fp-section, .fp-tableCell, .fp-scrollable
            height auto !important

        &.menuOpen
            overflow hidden !important
        
        .numbers_wraps
            &:after
                display none
                
        .fp-section:not([data-anchor="home"]), .fp-section:not([data-anchor="home"]) .fp-tableCell, .fp-section:not([data-anchor="home"]) .fp-scrollable
            height auto !important
            
        .iScrollVerticalScrollbar
            display none !important
            
        .fp-section[data-anchor="brands"]:not(.brands_open)
            // height 1180px !important
            background #fff
            
        .page__section
            padding-top 70px
            padding-bottom 70px
            
        .process__content_col, .cats_title, .automation__h1
            padding-top 0
            
        .channel__h2, .service__h2
            margin-top 0
            
        .numbers_wraps
            width 100%
            top 20px
            opacity 0
            
        .brList
            max-height 100vh
            
            &.active
                max-height 100%
            
            
            
            
        /* mobile animation
        ----------------------------------------------------------------*/
        .fp-section.startAnim
            .numbers_wraps
                position relative
                opacity 1
                top 0
                
                &[data-wraps="1"]
                    -webkit-transition-delay .5s
                    -moz-transition-delay .5s
                    transition-delay .5s
                    
                &[data-wraps="2"]
                    -webkit-transition-delay .7s
                    -moz-transition-delay .7s
                    transition-delay .7s
                    
                &[data-wraps="3"]
                    -webkit-transition-delay .9s
                    -moz-transition-delay .9s
                    transition-delay .9s
            
        
        
        
        
        
        
        
        
        
        
        /* end mobile animation
        ----------------------------------------------------------------*/
            
            
            
    body:not(.fp-responsive)
        .automation__item
            .textHide
                span
                    top 70px !important

            .automation__image svg path
                fill none
                stroke #000
                stroke-width .5px
                stroke-dasharray 1200px
                stroke-dashoffset 1200px
                -webkit-transition all 2s cubic-bezier(.25,.01,.25,1)
                -moz-transition all 2s cubic-bezier(.25,.01,.25,1)
                transition all 2s cubic-bezier(.25,.01,.25,1)

            .textFade
                top 20px !important
                opacity 0 !important
        
        
        .fp-section.startAnim
            .automation__item.visible_anim
                .textHide
                    span
                        top 0 !important

                .automation__image svg path
                    stroke-dashoffset 0
                    -webkit-transition-delay .3s
                    -moz-transition-delay .3s
                    transition-delay .3s

                .textFade
                    top 0 !important
                    opacity 1 !important
                    -webkit-transition-delay .6s !important
                    -moz-transition-delay .6s !important
                    transition-delay .6s !important
    
    
    
    
                
    @media (max-width 760px)
        .hide_mobi
            display none
            
        .mobi
            display block
            
    @media (min-width 761px)
        .hide_mobi
            display block
            
        .mobi
            display none
               

    @media (min-width 1025px)
        .aboutPage.startAnim
            .textHide
                span
                    top 0
                    
                &.sec_inst
                    span
                        top 0
                        -webkit-transition-delay .4s
                        -moz-transition-delay .4s
                        transition-delay .4s
                        
            .textFade
                opacity 1
                top 0
                -webkit-transition-delay .3s
                -moz-transition-delay .3s
                transition-delay .3s
                
                &.sec_inst
                    opacity 1
                    top 0
                    -webkit-transition-delay .7s
                    -moz-transition-delay .7s
                    transition-delay .7s
                    
                &.employees
                    opacity 1
                    top 0
                    -webkit-transition-delay 1s
                    -moz-transition-delay 1s
                    transition-delay 1s
                
                
        .contactPage.startAnim
            .textHide
                span
                    top 0
                    
            .textFade
                opacity 1
                top 0
                
                &[data-chain="1"]
                    -webkit-transition-delay .3s
                    -moz-transition-delay .3s
                    transition-delay .3s
                
                &[data-chain="2"]
                    -webkit-transition-delay .5s
                    -moz-transition-delay .5s
                    transition-delay .5s
                    
                &[data-chain="3"]
                    -webkit-transition-delay .7s
                    -moz-transition-delay .7s
                    transition-delay .7s
                    
                    
        .aboutPage.startAnim, .contactPage.startAnim
            .button
                opacity 1
                top 0

                &:before
                    width 76px
                    
                &:hover
                    transform translateX(24px)
                    
                    &:before
                        width 100%
                        padding-left 24px
                
                
                
    .fp-controlArrow
        display none !important
                
    @-webkit-keyframes bounceInDown {
        from,
        70%,
        90%,
        to {-webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);}

        0% {opacity: 0;-webkit-transform: translate3d(0, -100px, 0);transform: translate3d(0, -100px, 0);}
        70% {opacity: 1;-webkit-transform: translate3d(0, 15px, 0);transform: translate3d(0, 15px, 0);}
        90% {-webkit-transform: translate3d(0, 5px, 0);transform: translate3d(0, 5px, 0);}
        to {-webkit-transform: translate3d(0, 0, 0);transform: translate3d(0, 0, 0);}
    }

    @keyframes bounceInDown {
        from,
        70%,
        90%,
        to {-webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);}

        0% {opacity: 0;-webkit-transform: translate3d(0, -100px, 0);transform: translate3d(0, -100px, 0);}
        70% {opacity: 1;-webkit-transform: translate3d(0, 15px, 0);transform: translate3d(0, 15px, 0);}
        90% {-webkit-transform: translate3d(0, 5px, 0);transform: translate3d(0, 5px, 0);}
        to {-webkit-transform: translate3d(0, 0, 0);transform: translate3d(0, 0, 0);}
    }
	
    .seg_item
        width 50px
        height 26px
        position absolute
        top calc(50% - 13px)
        left calc(50% - 25px)
        z-index 5
        
        &svg
            width 100%
            height 100%
            
    
    @keyframes seg_A_axis {
        from,
        50%,
        to {-webkit-animation-timing-function: ease;animation-timing-function: ease;}
        
        0% {margin: -100px 0 0 70px;}
        50% {margin: -100px 0 0;}
        to {margin: 0;}
    }
    
    @keyframes seg_B_axis {
        from,
        50%,
        to {-webkit-animation-timing-function: ease;animation-timing-function: ease;}
        
        0% {margin: 100px 0 0 -70px;}
        50% {margin: 0 0 0 -70px;}
        to {margin: 0;}
    }
            
    @keyframes seg_C_axis {
        from,
        55%,
        to {-webkit-animation-timing-function: ease;animation-timing-function: ease;}
        
        0% {margin: 170px 0 0 120px;}
        55% {margin: 0 0 0 120px;}
        to {margin: 0;}
    }
    
    @keyframes seg_D_axis {
        from,
        55%,
        to {-webkit-animation-timing-function: ease;animation-timing-function: ease;}
        
        0% {margin: -170px 0 0 -120px;}
        55% {margin: 0 0 0 -120px;}
        to {margin: 0;}
    }
	
	.preloader_box {
		width 100vw
		height 100vh
		position absolute
		top 0
		left 0
		z-index 1000
		background #222
		overflow hidden
		-webkit-transition .3s ease
		-moz-transition .3s ease
		transition .3s ease
		
		&:before {
			width 100%
			height 100%
			position absolute
			top 0
			left 100vw
			background #141414
			content ''
			-webkit-transition .4s ease
			-moz-transition .4s ease
			transition .4s ease
		}
		
		&.startLoader {
			&:before {
				left 0
			}
		}
		
		&.endLoader {
			opacity 0
			-webkit-transition-delay .3s
			-moz-transition-delay .3s
			transition-delay .3s
			
			&:before {
				left -100vw
			}
			
			.loader_progress {
				opacity 0
			}
		}
		
		.seg_a {
			margin -100px 0 0 70px
		}
		.seg_b {
			margin 100px 0 0 -70px
		}
		.seg_c {
			margin 170px 0 0 120px
		}
		.seg_d {
			margin -170px 0 0 -120px
		}
		
		.loader_progress {
			width calc(100% - 160px)
			height 1px
			position absolute
			bottom 80px
			left 80px
			background rgba(255,255,255,.4)
			z-index 4
			-webkit-transition 3s ease
			-moz-transition 3s ease
			transition 3s ease
			
			&:after {
				width 0
				height 100%
				position absolute
				top 0
				left 0
				display block
				content ''
				background #fff
				-webkit-transition 3s linear
				-moz-transition 3s linear
				transition 3s linear
			}
		}
		
		
		&.startLoad {
			.seg_a {
				-webkit-animation: seg_A_axis 3s 1;
				-moz-animation: seg_A_axis 3s 1;
				animation: seg_A_axis 3s 1;
				-webkit-animation-fill-mode: forwards;
				-moz-animation-fill-mode: forwards;
				animation-fill-mode: forwards;
			}
			.seg_b {
				-webkit-animation: seg_B_axis 3s 1;
				-moz-animation: seg_B_axis 3s 1;
				animation: seg_B_axis 3s 1;
				-webkit-animation-fill-mode: forwards;
				-moz-animation-fill-mode: forwards;
				animation-fill-mode: forwards;
			}
			.seg_c {
				-webkit-animation: seg_C_axis 3s 1;
				-moz-animation: seg_C_axis 3s 1;
				animation: seg_C_axis 3s 1;
				-webkit-animation-fill-mode: forwards;
				-moz-animation-fill-mode: forwards;
				animation-fill-mode: forwards;
			}
			.seg_d {
				-webkit-animation: seg_D_axis 3s 1;
				-moz-animation: seg_D_axis 3s 1;
				animation: seg_D_axis 3s 1;
				-webkit-animation-fill-mode: forwards;
				-moz-animation-fill-mode: forwards;
				animation-fill-mode: forwards;
			}
			.loader_progress {
				&:after {
					width 100%
				}
			}
		}
	}

    
    .hero__h1 p
        margin 0
                
    .hero__h1 span.textHide
        display inline-block

    .hero__h1.mobi span
        @media (max-width: 760px)
            display block
    
    
</style>
